import { useCallback, useMemo, useState } from 'react'

import { isAdvertiser } from '~/helpers'
import { useAppInfo } from '~/hooks/useAppInfo'
import { useAppSelector } from '~/store/hooks'

type UseEditPanelOptions = {
  canEditCampaign?: boolean
  patchKey?: string
}

export function useEditPanel({
  canEditCampaign,
  patchKey = 'settings'
}: UseEditPanelOptions) {
  const { superAdmin } = useAppInfo()
  const [isEditMode, setIsEditMode] = useState(false)

  const loadingSave = useAppSelector(state =>
    state.retailMedia.industry.campaign.patch.loadingKeys.includes(patchKey)
  )

  const canEdit = useMemo(
    () => Boolean(isAdvertiser() && superAdmin && canEditCampaign),
    [canEditCampaign, superAdmin]
  )

  const handleSuccessSubmit = useCallback(() => {
    setIsEditMode(false)
  }, [])

  return {
    isEditMode,
    setIsEditMode,
    loadingSave,
    canEdit,
    handleSuccessSubmit
  }
}
